module.exports = __webpack_public_path__ + "img/logo-casa.828b316b.svg";